<div class="container-fluid glb-popup tpl-analytics-dialog">
  <p-toast [style]="{marginTop: '80px'}"></p-toast>

  <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:4px;">
    <h2 style="margin:0;">Template Analytics</h2>
    @if (!isPage) {
      <div style="display:flex; align-items:center; gap:2px;">
        <button mat-icon-button title="Open in new tab" style="background-color:transparent;" (click)="openInNewTab()">
          <i class="pi pi-external-link" style="font-size:14px; color:#1565c0;" aria-hidden="true"></i>
        </button>
        <button mat-icon-button [mat-dialog-close]="true" style="background-color:transparent;">
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
      </div>
    }
  </div>
  <hr>

    <!-- Filter Row -->
    <div class="tpl-filter-row">
      <div class="tpl-filter-field">
        <label class="tpl-field-label">Template</label>
        <p-dropdown [options]="msgTemplates" optionLabel="displayLabel" optionValue="msgTemplateId"
          [(ngModel)]="tplId" placeholder="Select Template" [filter]="true" filterBy="displayLabel"
          [showClear]="true" appendTo="body" dropdownIcon="fa fa-caret-down"
        [style]="{'width':'100%','font-size':'13px'}"></p-dropdown>
      </div>
      <div class="tpl-filter-field">
        <label class="tpl-field-label">Date From</label>
        <input pInputText type="date" [(ngModel)]="tplDateFrom" class="tpl-date-input" />
      </div>
      <div class="tpl-filter-field">
        <label class="tpl-field-label">Date To</label>
        <input pInputText type="date" [(ngModel)]="tplDateTo" class="tpl-date-input" />
      </div>
      <div class="tpl-filter-field tpl-filter-btn">
        <button pButton pRipple class="p-button p-button-sm" [loading]="loading"
          (click)="search()" [disabled]="!tplId">
          <i class="pi pi-search" style="margin-right:6px;"></i> Search
        </button>
      </div>
    </div>

    <!-- Loading -->
    @if (loading) {
      <div style="text-align:center; padding: 40px;">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
      </div>
    }

    <!-- Results -->
    @if (!loading && tplStats) {
      <div class="tpl-results">
        <!-- Selected Template Name -->
        @if (getSelectedTemplateName()) {
          <div class="tpl-selected-name">
            <i class="pi pi-file" style="margin-right:6px; color:#1565c0;"></i>
            <b>{{getSelectedTemplateName()}}</b>
            <span class="tpl-id-badge">ID: {{tplId}}</span>
          </div>
        }
        <!-- Stats Cards — Sent/Opened/Clicked are clickable to load recipients -->
        <div class="tpl-stats-row">
          <div class="tpl-stat-card tpl-stat-sent tpl-clickable" (click)="loadRecipients('all')"
            [class.tpl-card-active]="recipientType === 'all'"
            pTooltip="Total number of recipients this template was sent to. Click to see all recipients with their engagement status."
            tooltipPosition="bottom" [escape]="false">
            <div class="tpl-stat-value">{{tplStats.totalSent || 0}}</div>
            <div class="tpl-stat-label">Sent <i class="pi pi-external-link" style="font-size:9px;"></i></div>
          </div>
          <div class="tpl-stat-card tpl-stat-opened tpl-clickable" (click)="loadRecipients('opened')"
            [class.tpl-card-active]="recipientType === 'opened'"
            pTooltip="Unique recipients who opened the email at least once. Click to see the list."
            tooltipPosition="bottom">
            <div class="tpl-stat-value">{{tplStats.totalOpened || 0}}</div>
            <div class="tpl-stat-label">Opened <i class="pi pi-external-link" style="font-size:9px;"></i></div>
            @if (tplStats.totalSent > 0) {
              <div class="tpl-stat-sub">{{openRate | number:'1.1-1'}}%</div>
            }
          </div>
          <div class="tpl-stat-card tpl-stat-opens"
            pTooltip="Total number of open events across all recipients (includes multiple opens by the same recipient)."
            tooltipPosition="bottom">
            <div class="tpl-stat-value">{{tplStats.totalOpenedCount || 0}}</div>
            <div class="tpl-stat-label">Total Opens</div>
          </div>
          <div class="tpl-stat-card tpl-stat-clicked tpl-clickable" (click)="loadRecipients('clicked')"
            [class.tpl-card-active]="recipientType === 'clicked'"
            pTooltip="Unique recipients who clicked a tracked link at least once. Click to see the list."
            tooltipPosition="bottom">
            <div class="tpl-stat-value">{{tplStats.totalClicked_Recipients || 0}}</div>
            <div class="tpl-stat-label">Clicked <i class="pi pi-external-link" style="font-size:9px;"></i></div>
            @if (tplStats.totalSent > 0) {
              <div class="tpl-stat-sub">{{clickRate | number:'1.1-1'}}%</div>
            }
          </div>
          <div class="tpl-stat-card tpl-stat-clicks"
            pTooltip="Total number of link click events across all recipients (includes multiple clicks by the same recipient)."
            tooltipPosition="bottom">
            <div class="tpl-stat-value">{{tplStats.totalClickSum || 0}}</div>
            <div class="tpl-stat-label">Total Clicks</div>
          </div>
        </div>
        <!-- Funnel Bar -->
        @if (tplStats.totalSent > 0) {
          <div class="tpl-funnel">
            <h3 class="tpl-section-title">Engagement Funnel</h3>
            <div class="tpl-funnel-row">
              <span class="tpl-funnel-label">Sent</span>
              <div class="tpl-funnel-bar-wrap">
                <div class="tpl-funnel-bar tpl-bar-sent" style="width: 100%;"></div>
              </div>
              <span class="tpl-funnel-count">{{tplStats.totalSent}}</span>
            </div>
            <div class="tpl-funnel-row">
              <span class="tpl-funnel-label">Opened</span>
              <div class="tpl-funnel-bar-wrap">
                <div class="tpl-funnel-bar tpl-bar-opened"
                [ngStyle]="{'width': (tplStats.totalOpened / tplStats.totalSent * 100) + '%'}"></div>
              </div>
              <span class="tpl-funnel-count">{{tplStats.totalOpened}} ({{openRate | number:'1.1-1'}}%)</span>
            </div>
            <div class="tpl-funnel-row">
              <span class="tpl-funnel-label">Clicked</span>
              <div class="tpl-funnel-bar-wrap">
                <div class="tpl-funnel-bar tpl-bar-clicked"
                [ngStyle]="{'width': (tplStats.totalClicked_Recipients / tplStats.totalSent * 100) + '%'}"></div>
              </div>
              <span class="tpl-funnel-count">{{tplStats.totalClicked_Recipients}} ({{clickRate | number:'1.1-1'}}%)</span>
            </div>
          </div>
        }
        <!-- URL Click Breakdown -->
        @if (urlClicks.length > 0) {
          <div class="tpl-url-section">
            <h3 class="tpl-section-title">URL Click Breakdown</h3>
            <div class="tpl-url-table-wrap">
              <table class="tpl-url-table">
                <thead>
                  <tr>
                    <th style="text-align:center; width:50px;">#</th>
                    <th>Destination URL</th>
                    <th>Redirect URL</th>
                    <th style="text-align:center; width:80px;">Clicks</th>
                    <th style="text-align:center; width:90px;">Recipients</th>
                  </tr>
                </thead>
                <tbody>
                  @for (u of urlClicks; track u) {
                    <tr>
                      <td style="text-align:center; font-weight:600;">{{u.urlIndex != null ? u.urlIndex : '-'}}</td>
                      <td class="tpl-td-url" title="{{u.destinationUrl}}"><a [href]="u.destinationUrl" target="_blank" rel="noopener">{{u.destinationUrl}}</a></td>
                      <td class="tpl-td-url" title="{{u.redirectUrl}}"><a [href]="u.redirectUrl" target="_blank" rel="noopener">{{u.redirectUrl}}</a></td>
                      <td style="text-align:center; font-weight:600;">{{u.clickCount}}</td>
                      <td style="text-align:center;">{{u.recipientCount}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
        @if (urlLoading) {
          <div style="text-align:center; padding:16px;">
            <i class="pi pi-spin pi-spinner" style="font-size:1.2rem;"></i> Loading URL breakdown...
          </div>
        }
        <!-- No data message -->
        @if (tplStats.totalSent === 0) {
          <div class="tpl-no-data">
            <i class="pi pi-info-circle" style="font-size:1.5rem; color:#999; margin-bottom:8px;"></i>
            <p>No tracked links found for this template in the selected date range.</p>
          </div>
        }
        <!-- Recipient Detail Table -->
        @if (recipientType) {
          <div class="tpl-recipient-section">
            <h3 class="tpl-section-title">
              {{recipientType === 'all' ? 'All' : recipientType === 'opened' ? 'Opened' : 'Clicked'}} Recipients ({{recipients.length}})
            </h3>
            @if (recipientLoading) {
              <div style="text-align:center; padding:20px;">
                <i class="pi pi-spin pi-spinner" style="font-size:1.5rem;"></i>
              </div>
            }
            @if (!recipientLoading && recipients.length === 0) {
              <div class="tpl-no-data">
                <p>No recipients found.</p>
              </div>
            }
            @if (!recipientLoading && recipients.length > 0) {
              <div class="tpl-recipient-table-wrap">
                <table class="tpl-recipient-table">
                  <thead>
                    <tr>
                      @if (recipientType === 'all') {
                        <th>Status</th>
                      }
                      <th>Recipient Id</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Mobile</th>
                      <th>Msg Id</th>
                      <th>Source</th>
                      <th>Topic</th>
                      <th>Topic Id</th>
                      <th>Opened</th>
                      <th class="tpl-th-sort" (click)="sortRecipients('openedCount')">
                        Open# <i [class]="getSortIcon('openedCount')"></i>
                      </th>
                      <th>Deferred</th>
                      <th class="tpl-th-sort" (click)="sortRecipients('deferredCount')">
                        Defer# <i [class]="getSortIcon('deferredCount')"></i>
                      </th>
                      <th>Clicked</th>
                      <th class="tpl-th-sort" (click)="sortRecipients('clickedCount')">
                        Click# <i [class]="getSortIcon('clickedCount')"></i>
                      </th>
                      @if (recipientType === 'clicked') {
                        <th class="tpl-th-sort" (click)="sortRecipients('clickedUrl')">
                          Clicked URL <i [class]="getSortIcon('clickedUrl')"></i>
                        </th>
                      }
                      @if (recipientType === 'clicked') {
                        <th>Redirect URL</th>
                      }
                      @if (recipientType === 'clicked') {
                        <th class="tpl-th-sort" (click)="sortRecipients('linkClickedAt')">
                          Click Time <i [class]="getSortIcon('linkClickedAt')"></i>
                        </th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (r of pagedRecipients; track r) {
                      <tr>
                        @if (recipientType === 'all') {
                          <td>
                            <span class="tpl-engagement-badge"
                              [ngClass]="{'badge-clicked': r.engagementStatus === 'Clicked', 'badge-opened': r.engagementStatus === 'Opened', 'badge-not-opened': r.engagementStatus === 'Not Opened'}">
                              {{r.engagementStatus}}
                            </span>
                          </td>
                        }
                        <td>{{r.msgRecipientId}}</td>
                        <td>{{r.firstName}} {{r.lastName}}</td>
                        <td class="tpl-td-email">{{r.email}}</td>
                        <td>{{r.mobileCountryCode ? '+' + r.mobileCountryCode : ''}} {{r.mobileNum}}</td>
                        <td>
                          @if (r.msgId) {
                            <a class="tpl-msg-link" title="Open Message"
                              (click)="openMessage(r.msgId)">
                              {{r.msgId}}
                              <i class="pi pi-external-link" style="font-size:9px; margin-left:2px;"></i>
                            </a>
                          }
                          @if (!r.msgId) {
                            <span>-</span>
                          }
                        </td>
                        <td>{{r.sourceType}}</td>
                        <td>{{getTopicName(r.topic)}}</td>
                        <td>
                          @if (r.reservationId) {
                            <a class="tpl-res-badge tpl-res-link" title="Open Order"
                              (click)="openOrder(r.reservationId)">
                              Res# {{r.reservationId}}
                              @if (openingOrder[r.reservationId]) {
                                <i class="pi pi-spin pi-spinner" style="font-size:10px; margin-left:3px;"></i>
                              }
                            </a>
                          }
                          @if (!r.reservationId) {
                            <span>{{r.topicId || '—'}}</span>
                          }
                        </td>
                        <td class="tpl-td-date">{{r.openedDate | date:'M/d/yy h:mm a'}}</td>
                        <td style="text-align:center;">{{r.openedCount || 0}}</td>
                        <td class="tpl-td-date">{{r.deferredDate | date:'M/d/yy h:mm a'}}</td>
                        <td style="text-align:center;">{{r.deferredCount || 0}}</td>
                        <td class="tpl-td-date">{{r.clickedDate | date:'M/d/yy h:mm a'}}</td>
                        <td style="text-align:center;">{{r.clickedCount || 0}}</td>
                        @if (recipientType === 'clicked') {
                          <td class="tpl-td-url" title="{{r.clickedUrl}}">
                            @if (r.clickedUrl) {
                              <a [href]="r.clickedUrl" target="_blank" rel="noopener">{{r.clickedUrl}}</a>
                            }
                            @if (!r.clickedUrl) {
                              <span>-</span>
                            }
                          </td>
                        }
                        @if (recipientType === 'clicked') {
                          <td class="tpl-td-url" title="{{r.redirectUrl}}">
                            @if (r.redirectUrl) {
                              <a [href]="r.redirectUrl" target="_blank" rel="noopener">{{r.redirectUrl}}</a>
                            }
                            @if (!r.redirectUrl) {
                              <span>-</span>
                            }
                          </td>
                        }
                        @if (recipientType === 'clicked') {
                          <td class="tpl-td-date">{{r.linkClickedAt | date:'M/d/yy h:mm a'}}</td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
                <p-paginator [rows]="recipientPageSize" [totalRecords]="recipients.length"
                  [rowsPerPageOptions]="[25, 50, 100]" (onPageChange)="onRecipientPageChange($event)"
                [first]="recipientPage * recipientPageSize"></p-paginator>
              </div>
            }
          </div>
        }
      </div>
    }

    <!-- Initial state -->
    @if (!loading && !tplStats) {
      <div class="tpl-initial">
        <i class="pi pi-chart-line" style="font-size:2.5rem; color:#ccc;"></i>
        <p style="color:#999; margin-top:10px;">Select a template and click Search to view analytics.</p>
      </div>
    }

  </div>
